/**
 * Scale a size down to fit inside a bounding box, keeping its aspect ratio.
 *
 * The box is rotated to match the orientation of the size (landscape for wide
 * sizes), and a size that already fits is returned unchanged: it is never
 * upscaled.
 */
export const fitWithin = (
  width: number,
  height: number,
  box: [number, number]
): [number, number] => {
  const [short, long] = [...box].sort((a, b) => a - b);
  const [maxWidth, maxHeight] = width > height ? [long, short] : [short, long];
  const scale = Math.min(1, maxWidth / width, maxHeight / height);

  return [Math.max(1, Math.round(width * scale)), Math.max(1, Math.round(height * scale))];
};

export default fitWithin;
